module.exports = __webpack_public_path__ + "img/uk-cerebrovascular-disease-female.518bb2cb.png";